import { useState } from 'react';
import { Builder } from '@vojtechportes/react-query-builder';
import { useTranslation } from 'react-i18next';
import { Status } from 'helpers/StatusHelper';

const BotReportEditFilters = ({ onChange, schema, report }) => {
  const { t } = useTranslation();

  const initial_data = [
    {
      type: 'GROUP',
      value: 'AND',
      isNegated: false,
      children: report.filters || [],
    },
  ];

  const [data, setData] = useState(initial_data);

  const properties = Object.values(schema.properties || {});
  const props_keys = Object.keys(schema.properties || {});

  const strings = {
    group: {
      addRule: t('actions.add_rule'),
      delete: t('actions.delete'),
    },
    components: {
      delete: t('actions.delete'),
    },
    form: {
      selectYourValue: t('react_query_builder.select_value'),
    },
    operators: {
      LARGER: t('react_query_builder.larger'),
      SMALLER: t('react_query_builder.smaller'),
      LARGER_EQUAL: t('react_query_builder.larger_equal'),
      SMALLER_EQUAL: t('react_query_builder.smaller_equal'),
      EQUAL: t('react_query_builder.equal'),
      NOT_EQUAL: t('react_query_builder.not_equal'),
      NOT_IN: t('react_query_builder.not_in'),
      BETWEEN: t('react_query_builder.between'),
      NOT_BETWEEN: t('react_query_builder.not_between'),
      LIKE: t('react_query_builder.like'),
      NOT_LIKE: t('react_query_builder.not_like'),
    },
  };

  const operators = [
    'LARGER',
    'SMALLER',
    'LARGER_EQUAL',
    'SMALLER_EQUAL',
    'EQUAL',
    'NOT_EQUAL',
    'NOT_IN',
    'BETWEEN',
    'NOT_BETWEEN',
    'LIKE',
    'NOT_LIKE',
  ];

  const statusDesc = str => t(Status[str].tkey).toUpperCase();

  const fields = properties.map((prop, index) => {
    let type = prop.format || 'text';
    let value;

    const field = props_keys[index];

    if (field === 'status') {
      type = 'LIST';

      value = [
        { value: 'DONE', label: statusDesc('DONE') },
        { value: 'FAILED', label: statusDesc('FAILED') },
        { value: 'WORKING', label: statusDesc('WORKING') },
        { value: 'PENDING', label: statusDesc('PENDING') },
        { value: 'NOT_DONE', label: statusDesc('NOT_DONE') },
      ];
    }

    return {
      field: field,
      label: prop.title,
      type: type.toUpperCase(),
      value,
      operators,
    };
  });

  const getOp = operator => {
    const ops = {
      LARGER: 'gt',
      SMALLER: 'lt',
      LARGER_EQUAL: 'gte',
      SMALLER_EQUAL: 'lte',
      EQUAL: 'eq',
      NOT_EQUAL: 'ne',
      NOT_IN: 'notIn',
      BETWEEN: 'between',
      NOT_BETWEEN: 'notBetween',
      LIKE: 'iLike',
      NOT_LIKE: 'notILike',
    };

    return ops[operator];
  };

  const handleChange = data => {
    setData(data);

    const first = data[0] || {};
    const children = first.children || [];

    const rows = children.map(row => {
      return {
        ...row,
        op: getOp(row.operator),
      };
    });

    onChange(rows);
  };

  const components = {
    Add: ({ onClick, label }) => {
      if (label.toLowerCase().includes('group')) {
        return null;
      }
      return (
        <button className="btn btn-primary" style={{ width: 150 }} onClick={onClick}>
          {label}
        </button>
      );
    },
    GroupHeaderOption: () => null,
  };

  return <Builder strings={strings} readOnly={false} fields={fields} data={data} components={components} onChange={handleChange} />;
};

export default BotReportEditFilters;
